export const breadcrumbTitleKeys = {
  currentOrganisationName: 'CURRENT_ORGANISATION_NAME',
  currentGroupName: 'CURRENT_GROUP_NAME',
  currentUnitName: 'CURRENT_UNIT_NAME',
};
